import React from 'react';
import { remCalc } from '../util/style-util';
import { makeStyles } from '@mui/styles';
import { white, resourceDarkGray, resourceDarkGray2 } from '../styles/style-constants';

type Props = {
  title: string;
  icon: string;
  isDisabled: boolean;
  onClick: () => void;
};

function HomeTile(props: Props) {
  const { icon, title, isDisabled, onClick } = props;
  const { iconCss, homeTile } = useStyles(isDisabled);

  return (
    <div className={homeTile} onClick={isDisabled ? () => null : onClick}>
      <img src={icon} className={iconCss} alt={title} />
      <hr
        style={{
          color: '#dbdbdb',
          backgroundColor: '#dbdbdb',
          marginTop: '10px',
          marginBottom: '15px',
          width: '100%',
          height: '.6px'
        }}
      />
      <span style={{ marginBottom: '5px', fontSize: '18px', fontWeight: 300 }}>{title}</span>
    </div>
  );
}

const useStyles = makeStyles(() => {
  return {
    homeTile: disabled => ({
      backgroundColor: white,
      opacity: disabled ? '0.40' : '1.0',
      width: '100%',
      height: remCalc(220),
      margin: remCalc(10),
      paddingLeft: remCalc(20),
      paddingRight: remCalc(20),
      paddingTop: remCalc(10),
      paddingBottom: remCalc(10),
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      boxShadow: disabled ? '' : '0px 3px 7px 1px' + resourceDarkGray,
      border: remCalc(1) + ' solid' + resourceDarkGray,
      borderRadius: remCalc(3),
      justifyContent: 'space-between',
      color: resourceDarkGray2,
      cursor: disabled ? '' : 'pointer',
      userSelect: 'none',
      '&:hover': {
        transform: disabled ? 'scale(1.0,1.0)' : 'scale(1.05, 1.05)'
      }
    }),

    iconCss: {
      height: remCalc(120),
      margin: 'auto',
      marginBottom: remCalc(10)
    }
  };
});

export default HomeTile;
